<script setup>
// NOTICE: KAPTION-INTEGRATION
// Static Integrations-grid card for the Rumo MCP (connections live in
// KaptionRumoMcp.vue). Mirrors IntegrationItem's chrome but uses an icon
// instead of a bundled PNG logo.
import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';
import { frontendURL } from 'dashboard/helper/URLHelper';
import Button from 'dashboard/components-next/button/Button.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const getters = useStoreGetters();
const accountId = getters.getCurrentAccountId;

const actionURL = computed(() =>
  frontendURL(`accounts/${accountId.value}/settings/integrations/rumo-mcp`)
);
</script>

<template>
  <div
    class="flex flex-col flex-1 p-6 m-[1px] outline outline-n-container outline-1 bg-n-alpha-3 rounded-md shadow"
  >
    <div class="flex items-start justify-between">
      <div
        class="flex items-center justify-center h-12 w-12 mb-4 rounded-md border border-n-weak shadow-sm bg-n-alpha-3"
      >
        <Icon icon="i-lucide-plug-zap" class="size-6 text-n-slate-11" />
      </div>
    </div>
    <div class="flex flex-col m-0 flex-1">
      <div
        class="font-medium mb-2 text-n-slate-12 flex justify-between items-center"
      >
        <span class="text-base font-semibold">
          {{ $t('KAPTION_MCP_INTEGRATION.NAME') }}
        </span>
        <router-link :to="actionURL">
          <Button :label="$t('INTEGRATION_APPS.CONFIGURE')" link />
        </router-link>
      </div>
      <p class="text-n-slate-11">
        {{ $t('KAPTION_MCP_INTEGRATION.SHORT_DESCRIPTION') }}
      </p>
    </div>
  </div>
</template>
